import { node } from "~/util/dom";
import { IReviewItem } from "~/review/interfaces";
import { createEmojisPreview } from "~/ui/review/emojisPreview";
import { createSmallStars } from "../review/stars";

export function generateReviewLine(data: IReviewItem): HTMLDivElement {
	const container = node("div", { className: "review-line" });
	const date = data.updated ? new Date(data.updated) : null;
	const dateString = date ? Mapy.Util.dateToLocaleFormatLocal(date) : "";

	container.appendChild(createSmallStars({
		rating: data.rating,
	}));
	container.appendChild(node("span", { className: "update-date" }, dateString));

	if (data.structured_rating?.length) {
		const structuredEmoji = createEmojisPreview({
			config: data.structured_rating,
		});

		if (!structuredEmoji.isHidden) {
			container.appendChild(structuredEmoji.container);
		}
	}

	return container;
}
